import React from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, Link } from "react-router-dom";
import guide from "services/guide";

const StyledHeaderContainer = styled.div`
  /* background-color: ${({ theme }) => theme.secondBackgroundColor}; */
  background-color: transparent;
  /* box-shadow: ${({ theme }) => theme.boxShadow}; */
`;

const StyledHeader = styled.header`
  font-family: ${({ theme }) => theme.font.youshe};
  color: ${({ theme }) => theme.white};
  padding: 25px 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.large};
  background-color: ${({ theme }) => theme.black};
  box-shadow: ${({ theme }) => theme.boxShadow};

  overflow: hidden;
`;

const StyledHeaderContent = styled.div`
  cursor: pointer;
  transition: 0.4s;
  :hover {
    transform: scale(1.1);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: unset;
`;

const Header = () => {
  return (
    <StyledHeaderContainer>
      <StyledHeader>
        <StyledHeaderContent>
          <StyledLink to="/">插件升级</StyledLink>
        </StyledHeaderContent>
      </StyledHeader>
    </StyledHeaderContainer>
  );
};

export default Header;
